const listOffEventListener = {};
function messageListener({ source, data }, expectedHref, callback) {
    const currentHref = source.location.href.split('?')[0].split('#')[0];
    if (currentHref.includes(expectedHref) && callback)
        callback(data);
}
export function getMessageFromParent(expectedHref, callback) {
    const eventListener = ({ source, data }) => messageListener({ source, data }, expectedHref, callback);
    listOffEventListener[expectedHref] = eventListener;
    window.addEventListener('message', eventListener);
}
export function removeMessageFromParent(expectedHref) {
    const eventListener = listOffEventListener[expectedHref];
    window.removeEventListener('message', eventListener);
}
export function postMessageToParent(data, sameIframe) {
    if (typeof window === 'undefined')
        return;
    if (sameIframe)
        window.postMessage(data, '*');
    else
        window.parent.postMessage(data, '*');
}
//# sourceMappingURL=infrastructure.js.map